// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Nh-g","sk-bouncedelay":"Spinner_sk-bouncedelay__3TnNw","bounce1":"Spinner_bounce1__1kCR3","bounce2":"Spinner_bounce2__1p-9F"};